












































































import Vue, { PropType } from 'vue';
import { mapActions, mapGetters } from 'vuex';

import { setErrorFromAxiosError } from '@/utils/helpers';
import { ISystemError } from '@/models/error/error.types';
import {
  DocumentTag,
  IDocumentTag,
  IQuoteDocumentTag,
  QuoteDocumentTag
} from '@/models';
import { SystemError } from '@/models/error/error';

export default Vue.extend({
  name: 'DocumentDetailTagPicker',

  model: {
    prop: 'value',
    event: 'input'
  },

  props: {
    value: Array as PropType<number[]>,
    externalErrorMessage: {
      type: Array as PropType<string[]>,
      default: () => []
    },
    hideCreateBtn: Boolean
  },

  data() {
    return {
      lazyValue: this.value,
      loading: false,
      error: null as ISystemError | null,
      search: ''
    };
  },

  computed: {
    ...mapGetters({
      getQuoteDocumentTags: 'document/getQuoteDocumentTags',
      getLatestQuoteDocumentTag: 'document/getLatestQuoteDocumentTag'
    }),

    internalValue: {
      get(): number[] {
        return this.lazyValue;
      },
      set(val: number[]) {
        this.lazyValue = val;
        this.$emit('input', val);
      }
    },

    documentTags(): IDocumentTag[] {
      return this.getQuoteDocumentTags.map(
        (quoteTag: IQuoteDocumentTag) => new DocumentTag(quoteTag.tag)
      );
    },

    latestQuoteDocumentTag(): IQuoteDocumentTag {
      return this.getLatestQuoteDocumentTag;
    },

    errorMessageList(): string[] {
      let errorList: string[] = [];
      if (this.externalErrorMessage) {
        errorList = this.externalErrorMessage;
      }
      if (this.error) {
        errorList.push(`${this.error.message} - ${this.error.detail}`);
      }

      return errorList;
    }
  },

  watch: {
    value: {
      handler(val) {
        this.lazyValue = val; // Sync lazyValue with the external prop value
      },
      immediate: true
    }
  },

  mounted() {
    this.loading = true;
    this.fetchQuoteDocumentTags()
      .catch(error => {
        this.error = setErrorFromAxiosError(error);
      })
      .finally(() => (this.loading = false));
  },

  methods: {
    ...mapActions({
      fetchQuoteDocumentTags: 'document/fetchQuoteDocumentTags',
      createQuoteDocumentTag: 'document/createQuoteDocumentTag'
    }),

    hoverListItemClass(hover: boolean) {
      return !this.search
        ? 'white grey--text'
        : hover
        ? 'primary white--text'
        : 'white primary--text';
    },

    /**
     * Custom filter is needed to search for list items
     */
    itemSearch(item: any, queryText: string, itemText: string) {
      return (
        (item.toString() || '')
          .toLowerCase()
          .indexOf((queryText || '').toLowerCase()) > -1
      );
    },

    addTag() {
      let documentInstance: IQuoteDocumentTag | null = null;

      try {
        documentInstance = new QuoteDocumentTag({
          tag: { label: this.search }
        });
      } catch (error) {
        if (SystemError.isSystemError(error)) {
          this.error = error;
        }
      }

      if (documentInstance != null) {
        this.loading = true;
        this.createQuoteDocumentTag(documentInstance)
          .then(() => {
            this.internalValue.push(this.latestQuoteDocumentTag.tag.id!);
            this.search = '';
          })
          .catch(error => {
            this.error = setErrorFromAxiosError(error);
          })
          .finally(() => (this.loading = false));
      }
    }
  }
});
